import type { MeetingPlatform, MeetingStatus, MeetingType } from '@/api/schema';
import type { ChipTone } from '@/components/ui/Chip';

export const MEETING_TYPE_LABEL: Record<MeetingType, string> = {
  discovery_call: 'Discovery call',
  flyst_screening: 'Flyst screening',
  rsr_screening: 'RSR screening',
  interview: 'Interview',
  follow_up: 'Follow-up',
};

/**
 * A colour per type, reusing the status palette rather than adding five more.
 *
 * The two screening types deliberately borrow the colours those boards already use, so
 * a Flyst screening looks the same wherever it turns up.
 */
export const MEETING_TYPE_TONE: Record<MeetingType, ChipTone> = {
  discovery_call: 'applied',
  flyst_screening: 'details-mailed',
  rsr_screening: 'rsr-arranged',
  interview: 'approved',
  follow_up: 'onboarding',
};

export const PLATFORM_LABEL: Record<MeetingPlatform, string> = {
  zoom: 'Zoom',
  phone: 'Phone',
  whatsapp: 'WhatsApp',
  in_person: 'In person',
};

export const MEETING_STATUS_LABEL: Record<MeetingStatus, string> = {
  scheduled: 'Scheduled',
  completed: 'Completed',
  no_show: 'No show',
  rescheduled: 'Rescheduled',
  cancelled: 'Cancelled',
};

export const MEETING_STATUS_TONE: Record<MeetingStatus, ChipTone> = {
  scheduled: 'applied',
  completed: 'approved',
  no_show: 'rejected',
  rescheduled: 'hold',
  cancelled: 'neutral',
};

export const MEETING_TYPE_OPTIONS = (Object.keys(MEETING_TYPE_LABEL) as MeetingType[]).map(
  (value) => ({ value, label: MEETING_TYPE_LABEL[value] }),
);
export const PLATFORM_OPTIONS = (Object.keys(PLATFORM_LABEL) as MeetingPlatform[]).map(
  (value) => ({ value, label: PLATFORM_LABEL[value] }),
);
export const MEETING_STATUS_OPTIONS = (
  Object.keys(MEETING_STATUS_LABEL) as MeetingStatus[]
).map((value) => ({ value, label: MEETING_STATUS_LABEL[value] }));

/** Durations people actually book, rather than a free number field. */
export const DURATION_OPTIONS = [15, 30, 45, 60, 90, 120].map((minutes) => ({
  value: String(minutes),
  label:
    minutes >= 60 ? `${minutes / 60} hour${minutes === 60 ? '' : 's'}` : `${minutes} minutes`,
}));
